import { Component, OnInit, ViewChild } from '@angular/core';
import { ClientServiceService } from '../services/client-service.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { SubscriptionServiceService } from '../services/subscription-service.service';
import { TranslateService } from '@ngx-translate/core';


interface SubscriptionPlan {
  emails: number;
  people: number;
}

interface AvailableEmailsCondition {
  [key: string]: SubscriptionPlan;
}

interface SubscriptionData {
  product: string;
}

@Component({
  selector: 'app-emails-monitoring',
  templateUrl: './emails-monitoring.component.html',
  styleUrls: ['./emails-monitoring.component.css']
})
export class EmailsMonitoringComponent implements OnInit {

  auth_client_token: any = null;

  emails: any = [];
  email: string = "";
  customer_email: string = "";
  is_already_used_email: boolean = false;

  isPersonalEmailChecked: boolean = true;
  isInviteEmailChecked: boolean = false;
  isInviteEmailVisible: boolean = false;

  isPersonalEmailSubmited: boolean = false;
  isInviteEmailSubmited: boolean = false;

  hasAvailableEmails: boolean = false;

  availableEmailsCondition: AvailableEmailsCondition = {};

  // availableEmailsCondition: AvailableEmailsCondition = {
  //   "removia-advanced-12-months": {
  //     emails: 3,
  //     people: 3
  //   },
  //   "removia-lite-12-months":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-pro-12-months": {
  //     emails: 2,
  //     people: 2
  //   },
  //   "removia-ultimate-12-months": {
  //     emails: 5,
  //     people: 5
  //   },
  //   "removia-premium": {
  //     emails: 5,
  //     people: 5
  //   },
  //   "removia-monthly":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-yearly":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-1-month":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-1-year":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-3-month":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "removia-3-months":  {
  //     emails: 1,
  //     people: 1
  //   },
  //   "yourtechpal-remote-assistance-12-month-plan":  {
  //     emails: 3,
  //     people: 3
  //   },
  //   "yourtechpal-remote-assistance-24-month-plan":  {
  //     emails: 3,
  //     people: 3
  //   },
  //   "yourtechpal-remote-assistance-36-month-plan":  {
  //     emails: 5,
  //     people: 5
  //   },
  // };

  available_emails: number = 0;
  used_emails: number = 0;

  auth_forms: any;
  subcostomers: any;

  // error_message = "This email is already used for monitoring or used other customer.";
  error_message = this.getTranslation('already_used_error');
  deletion_success_message: any = null;
  deletion_error_message: any = null;

  isDeletionModalOpen: boolean = false;
  deletion_email: any;

  @ViewChild('emailForm') emailForm!: NgForm;

  constructor(
    private client_service: ClientServiceService,
    private router: Router,
    private subscription_service: SubscriptionServiceService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.auth_client_token = localStorage.getItem("auth_client_token");
    if (!this.auth_client_token) {
      this.router.navigate(["/login"]);
    };
    this.get_all_plans();
  }

  getTranslation(key: string, params?: any): string {
    return this.translate.instant(`email_monitoring.${key}`, params || {});
  }

  get_all_plans() {
    this.client_service.get_plans(this.auth_client_token).subscribe({
      next: (data) => {
        this.availableEmailsCondition = data;
        this.get_customer_forms();
      },
      error: (err) => {
        if (err.status === 401) {
          this.router.navigate(["/login"]);
        }
      }
    })
  }

  get_customer_detail() {
    this.client_service.get_customer_info(this.auth_client_token).subscribe({
      next: (data) => {
        if (data.parent_id || data.status !== 'Active') {
          this.router.navigate(["/dashboard"]);
        }
        this.customer_email = data.email;
        this.subcostomers = data.subcustomers;
        this.emails = [
          ...this.emails,
          ...data.subcustomers.map((customer: any) => (
            {
              type: "Invite",
              value: customer.email
            }
          ))
        ];
        this.get_customer_subscription();
      },
      error: (err) => {
        if (err.status === 401) {
          this.router.navigate(["/login"]);
        }
      }
    })
  }

  get_customer_subscription() {
    this.subscription_service.get_active_subscription(this.auth_client_token).subscribe({
      next: (data: SubscriptionData) => {
        this.available_emails = this.availableEmailsCondition[data.product].emails - this.emails.length;
        this.used_emails = this.emails.length;
        if (this.available_emails > 0) {
          this.hasAvailableEmails = true;
        }
        const invited_emails = this.emails.filter((email: any) => email.type === "Invite");
        this.isInviteEmailVisible = (this.availableEmailsCondition[data.product].people - invited_emails.length - 1) > 0;
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  get_customer_forms() {
    this.client_service.get_client_forms(this.auth_client_token).subscribe({
      next: (data) => {
        if (data.length === 0) {
          this.router.navigate(["/dashboard"]);
          return;
        }
        this.auth_forms = data;
        this.emails = [
          ...data.map((form: any) => (
            {
              type: "Personal",
              value: form.email
            }
          ))
        ];
        this.get_customer_detail();
      },
      error: (err) => {
        if (err.status === 401) {
          this.router.navigate(["/login"]);
        }
      }
    })
  }

  onCheckboxChange(email_type: string) {
    if (email_type === 'personal') {
      this.isPersonalEmailChecked = true;
      this.isInviteEmailChecked = false;
    } else if (email_type === 'invite') {
      this.isPersonalEmailChecked = false;
      this.isInviteEmailChecked = true;
    }
  }

  onEmailChange(event: Event) {
    this.is_already_used_email = false;
    const input = event.target as HTMLInputElement;
    this.email = input.value.toLowerCase();
  }

  async onEmailSubmit() {
    await this.validatePersonalEmail()
    if (this.is_already_used_email) {
      return
    }

    if (this.isPersonalEmailChecked) {
      this.isPersonalEmailSubmited = true;
      const isSafari = /safari/i.test(navigator.userAgent) && !/chrome|crios|fxios|android/i.test(navigator.userAgent);

      if (isSafari) {
        const link = document.createElement('a');
        link.href = `/dashboard?email=${this.email}`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setTimeout(() => {
          window.open(`/dashboard?email=${this.email}`, '_blank');
        }, 2000)
      }
    }

    if (this.isInviteEmailChecked) {
      if (this.customer_email === this.email) {
        this.is_already_used_email = true;
        return;
      }
      this.send_invitation_on_email()
    }
  }

  async validatePersonalEmail(): Promise<{ valid: boolean; message?: string }> {
    return new Promise((resolve) => {
      this.client_service.get_auth_form_by_email(this.auth_client_token, this.email).subscribe({
        next: (data) => {
          this.is_already_used_email = true;
          resolve({ valid: false });
        },
        error: (err) => {
          if (err.status === 404) {
            this.is_already_used_email = false;
            resolve({ valid: true });
          } else {
            this.is_already_used_email = true;
            this.error_message = this.getTranslation('validation_error');
            resolve({ valid: false, message: this.error_message });
          }
        }
      });
    });
  }

  send_invitation_on_email() {
    this.client_service.invite_customer(this.auth_client_token, this.email).subscribe({
      next: (data) => {
        this.isInviteEmailSubmited = true;
        this.ngOnInit();
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  check_filling_possibility() {
    this.client_service.check_possibility_filling(this.auth_client_token).subscribe({
      next: (data) => {
        if (!data.can_fill) {
          this.hasAvailableEmails = false;
        } else {
          this.email = "";
          this.emailForm?.resetForm();
          this.isPersonalEmailChecked = true;
          this.isInviteEmailChecked = false;
        }
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  handleOpenModal() {
    this.isInviteEmailSubmited = false;
    this.isPersonalEmailSubmited = false;
    this.check_filling_possibility();
  }

  openDeletionModal(email: any) {
    this.isDeletionModalOpen = true;
    this.deletion_email = email;
    this.deletion_success_message = null;
    this.deletion_error_message = null;
  }

  closeDeletionModal(event: Event) {
    const target = event.target as any;
    const currentTarget = event.currentTarget as any;

    if (target === currentTarget || target.dataset.action === "keep") {
      this.isDeletionModalOpen = false;
    }
  }

  handle_deletion_auth_form() {
    if (this.deletion_email.type === "Invite") {
      const child = this.subcostomers.find(({email}: any) => email === this.deletion_email.value);
      this.client_service.delete_child_form(this.auth_client_token, child.id).subscribe({
        next: (data) => {
          this.deletion_success_message = this.getTranslation('deletion_success', { email: this.deletion_email.value });
          setTimeout(() => {
            this.deletion_success_message = null;
            window.location.reload();
          }, 1000);
        },
        error: (err) => {
          this.deletion_error_message = this.getTranslation('deletion_error');
          setTimeout(() => {
            this.deletion_error_message = null;
          }, 1000);
        }
      })
    } else {
      const auth_form = this.auth_forms.find(({email}: any) => email === this.deletion_email.value);
      this.client_service.delete_auth_form(this.auth_client_token, auth_form.id).subscribe({
        next: (data) => {
          this.deletion_success_message = this.getTranslation('deletion_success', { email: this.deletion_email.value });
          setTimeout(() => {
            this.deletion_success_message = null;
            window.location.reload();
          }, 1000);
        },
        error: (err) => {
          this.deletion_error_message = this.getTranslation('deletion_error');
          setTimeout(() => {
            this.deletion_error_message = null;
          }, 1000);
        }
      })
    }
  }
}
